import React from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { NavBoundaryProvider, useNavBoundaryContext } from '../controllers/nav-boundary-provider';

import { ErrorBoundaryUI } from './error-boundary-ui';
import type { NavErrorBoundaryProps } from './types';

export function NavErrorBoundary(props: NavErrorBoundaryProps) {
	return (
		<NavBoundaryProvider {...props}>
			<InnerErrorBoundary {...props} />
		</NavBoundaryProvider>
	);
}

function InnerErrorBoundary({
	children,
	disableAnalytics = false,
	location = 'unknown',
	showFlags,
	silent = false,
	...rest
}: Pick<
	NavErrorBoundaryProps,
	| 'children'
	| 'disableAnalytics'
	| 'location'
	| 'showFlags'
	| 'silent'
	| 'errorFallbackUI'
	| 'errorActionUI'
>) {
	const { handleError } = useNavBoundaryContext();

	// When `silent` is true or `flags` are enabled, we don't want to show any UI on error
	const errorComponent = silent ? null : showFlags ? null : (
		<ErrorBoundaryUI {...rest} location={location} disableAnalytics={disableAnalytics} />
	);

	return (
		<ErrorBoundary onError={handleError} fallback={errorComponent}>
			{children}
		</ErrorBoundary>
	);
}
